export const config = {
  cal: {
    link: process.env.NEXT_PUBLIC_CAL_LINK,
    namespace: "book-session",
  },
  resend: {
    // Server-only key. Reading it here is safe: it is not a NEXT_PUBLIC_ var, so
    // Next never inlines it into the client bundle (it is undefined on the client).
    apiKey: process.env.RESEND_API_KEY,
  },
} as const;
